import { createReactComponent } from "./utils/limelReactWrapper";

export const LimelInput = createReactComponent("limel-input-field");
export const LimelSwitch = createReactComponent("limel-switch");
export const LimelTabs = createReactComponent("limel-tab-bar");
export const LimelBtn = createReactComponent("limel-button");
export const LimelBtnGroup = createReactComponent("limel-button-group");
export const LimelIconButton = createReactComponent("limel-icon-button");
export const Datepicker = createReactComponent("limel-date-picker");
export const LimelCheckbox = createReactComponent("limel-checkbox");
export const Slider = createReactComponent("limel-slider");
export const LimelMenu = createReactComponent("limel-menu");
export const LimelSelect = createReactComponent("limel-select");
export const LimelDialog = createReactComponent("limel-dialog");
export const LimelCallout = createReactComponent("limel-callout");
export const LimelIcon = createReactComponent("limel-icon");
